module.exports = __webpack_public_path__ + "premium_purchase_icon_6.png?b29344c7a6609c3598a3a2203c9181cf";


//////////////////
// WEBPACK FOOTER
// ./static/img/premium_purchase_icon_6.png
// module id = 340
// module chunks = 0